export { SegmentedControl } from './SegmentedControl';
